import React from 'react';

export const featureFlagsContext = React.createContext<string>('');
